import { render, staticRenderFns } from "./PaywallMenu.vue?vue&type=template&id=ba7cdfaa&scoped=true"
import script from "./PaywallMenu.vue?vue&type=script&lang=js"
export * from "./PaywallMenu.vue?vue&type=script&lang=js"
import style0 from "./PaywallMenu.vue?vue&type=style&index=0&id=ba7cdfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7cdfaa",
  null
  
)

export default component.exports